import { TCAppConfig } from "../../../../shared/app-configs/tc-app-configs";
import apiService from "../../../../shared/service/api-service";

export const dtrackItServiceV4 = {
    async getOrganicFarmStandards() {
        const queryParams = {
            query_param: TCAppConfig.GET_ORGANIC_FARM_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getStandradLabelGrade() {
        const queryParams = {
            query_param: TCAppConfig.GET_STANDARD_LABEL_GRADE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getProductCategory() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getProductDetailsCode() {
        const queryParams = {
            query_param: TCAppConfig.GET_PRODUCT_DETAIL_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getCountry() {
        const queryParams = {
            query_param: TCAppConfig.GET_COUNTRY_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getStateBasedonCountry(country: any) {
        const queryParams = {
            query_param: TCAppConfig.GET_STATE_CODE,
            country: country
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getRawMaterialCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_RAW_MATERIAL_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getCBLicensingCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_CBLICENSING_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getFacilityProcessCategoryCodes() {
        const queryParams = {
            query_param: TCAppConfig.GET_FACILITY_PROCESS_CATEGORY_CODE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getStandradLabelGradeOnBasisOfSelectedStandard(standard: string[]) {
        const queryParams = {
            standard: [...standard,"NA"],
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    // New v4 specific methods
    async getDTrackItSCNumbers(scCbLicensingCode: string) {
        const queryParams = {
            scCbLicensingCode: scCbLicensingCode
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_SC_NO_V4, queryParams)
        return response;
    },

    async getDTrackItCONames(scCbLicensingCode: string) {
        const queryParams = {
            scCbLicensingCode: scCbLicensingCode
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_CO_NAME_V4, queryParams)
        return response;
    },

    async getSCDTrackItTransactions(scCbLicensingCode: string) {
        const queryParams = {
            scCbLicensingCode: scCbLicensingCode
        }
        const response = await apiService.get<any>(TCAppConfig.GET_SC_DTRACKIT_TRANSACTIONS_V4, queryParams)
        return response;
    },

    async getDTrackItRefCodes(queryParam: string, country?: string, limit?: number, offset?: number, standard?: string) {
        const queryParams: any = {
            query_param: queryParam
        }
        if (country) queryParams.country = country;
        if (limit) queryParams.limit = limit;
        if (offset) queryParams.offset = offset;
        if (standard) queryParams.standard = standard;
        
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    // Additional v4 methods
    async getSCStatus() {
        const queryParams = {
            query_param: TCAppConfig.GET_SC_STATUS
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },
    async getSCStatusV4() {
        const queryParams = {
            query_param: TCAppConfig.GET_SC_STATUS_V4
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },
    async getSuspensionReason() {
        const queryParams = {
            query_param: TCAppConfig.GET_SUSPENSION_REASON
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getScStandardValues() {
        const queryParams = {
            query_param: TCAppConfig.GET_SC_STANDARD_VALUES
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getStandardWithdrawalReasonValues() {
        const queryParams = {
            query_param: TCAppConfig.GET_STANDARD_WITHDRAWAL_REASON_VALUES
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getCertifiedOrganizationApprovedClaimsValues() {
        const queryParams = {
            query_param: TCAppConfig.GET_CERTIFIED_ORGANIZATION_APPROVED_CLAIMS_VALUES
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getCertifiedOrganizationApprovedClaimsValuesLG() {
        const queryParams = {
            query_param: TCAppConfig.GET_STANDARD_LABEL_GRADE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getAccreditationBody() {
        const queryParams = {
            query_param: TCAppConfig.GET_ACCREDITATION_BODY
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getScNonMandatoryCriterionStandardValues() {
        const queryParams = {
            query_param: TCAppConfig.GET_SC_NON_MANDATORY_CRITERION_STANDARD_VALUES
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getFacilityType() {
        const queryParams = {
            query_param: TCAppConfig.GET_FACILITY_TYPE
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getFacilityCbOfIndependentlyCertifiedSubcontractor() {
        const queryParams = {
            query_param: TCAppConfig.GET_FACILITY_CB_OF_INDEPENDENTLY_CERTIFIED_SUBCONTRACTOR
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getStandardVersions(standard: string) {
        const queryParams = {
            query_param: "VER", // Version query parameter
            standard: standard
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getNonMandatoryCriterionStandardValues() {
        const queryParams = {
            query_param: "NMCSD" // Non-Mandatory Criterion Standard query parameter
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getNonMandatoryCriterionStandardVersions(standard: string) {
        const queryParams = {
            query_param: "NMCVER", // Non-Mandatory Criterion Version query parameter
            standard: standard
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getNonMandatoryCriterionNumbers() {
        const queryParams = {
            query_param: "NMCRI" // Non-Mandatory Criterion Number query parameter
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },

    async getNonMandatoryCriterionStatusValues() {
        const queryParams = {
            query_param: "NMCSTS" // Non-Mandatory Criterion Status query parameter
        }
        const response = await apiService.get<any>(TCAppConfig.GET_DTRACKIT_REF_CODE_V4, queryParams)
        return response;
    },
}
